import React from 'react';
import UploadTabSkeleton from '../UploadTabSkeleton';
import ANPRMetadata from '../../../Metadata/ANPRMetadata';
import { getANPRTypes } from '../../../../utils/string';
import TabHeader from '../../../TabHeader';
import { UploadFormProvider } from '../UploadFormContext';

const ANPRTab: React.FC = () => {
	return (
		<UploadFormProvider>
			<TabHeader />
			<UploadTabSkeleton allowedFormats={getANPRTypes()} testTag="anpr-tab-content" noSuspect>
				<ANPRMetadata />
			</UploadTabSkeleton>
		</UploadFormProvider>
	);
};

export default ANPRTab;
